import React from 'react';
import DateFormat from '../../../commons/componentes/DateFormat';
import { EMPRESA_VENCIMIENTO_DATE_PATTERN } from '../../../shared/date/date-formats';
import { FaPencilAlt } from '@react-icons/all-files/fa/FaPencilAlt';

const GrupoEmpresasTabla = (props: any) => {

    const { empresaId, empresas, seleccionarEmpresa, deseleccionarEmpresa, onEditarEmpresa, canEditGrupoEmpresas }: { empresaId: string | undefined; empresas: any[], seleccionarEmpresa?: any, deseleccionarEmpresa?: any, onEditarEmpresa?: (empresa: any) => void, canEditGrupoEmpresas?: boolean } = props;

    const selectedEmpresaId =
        empresaId != null && empresaId !== 'new' && empresaId !== ''
            ? Number(empresaId)
            : null;


    console.log('App loading');



    return (
        <div style={{ overflowX: 'auto', width: '100%' }}>
            <table className="table tabla-chica" style={{ minWidth: 640 }}>
                <thead>
                    <tr className='bg-primary'>
                        <th>Razón Social</th>
                        <th>RFC</th>
                        <th>Venc. Sellos</th>
                        <th>Clave Fiel</th>
                        <th>Venc. Fiel</th>
                        <th>Clave Ciec</th>
                        <th>Status</th>
                        <th></th>
                    </tr>
                </thead>
                <tbody>
                    {empresas.map((empresa, index: number) => (
                        <tr key={empresa.id ?? index}
                            className={selectedEmpresaId != null && empresa.id === selectedEmpresaId ? "selected" : ""}
                        >
                            <td>{empresa.razonSocial}</td>
                            <td>{empresa.rfc}</td>
                            <td><DateFormat value={empresa.vsellos} pattern={EMPRESA_VENCIMIENTO_DATE_PATTERN} highlightIfBeforeToday /></td>
                            <td>{empresa.cfiel}</td>
                            <td><DateFormat value={empresa.vfiel} pattern={EMPRESA_VENCIMIENTO_DATE_PATTERN} highlightIfBeforeToday /></td>
                            <td>{empresa.cciec}</td>
                            <td style={{ textAlign: 'center' }}>
                                {empresa.estatus == null || empresa.estatus === ''
                                    ? <span style={{ color: '#94a3b8' }}>{empresa.estatusT ?? '—'}</span>
                                    : empresa.estatus == 0
                                      ? <span style={{ color: '#ef4444', fontWeight: 600 }}>Inactivo</span>
                                      : empresa.estatus == 1
                                        ? <span style={{ color: '#22c55e', fontWeight: 600 }}>Activo</span>
                                        : empresa.estatus == 2
                                          ? <span style={{ color: '#f59e0b', fontWeight: 600 }}>Incubado</span>
                                          : <span style={{ color: '#94a3b8' }}>{empresa.estatusT ?? '—'}</span>
                                }
                            </td>
                            <td>
                                <div className="d-inline-flex align-items-center gap-1 flex-wrap">
                                    {canEditGrupoEmpresas && onEditarEmpresa ? (
                                        <button
                                            type="button"
                                            className="btn btn-sm btn-light d-inline-flex align-items-center justify-content-center"
                                            style={{ padding: '4px 8px' }}
                                            onClick={() => onEditarEmpresa(empresa)}
                                            title="Editar empresa"
                                            aria-label="Editar empresa"
                                        >
                                            <FaPencilAlt />
                                        </button>
                                    ) : null}
                                    {selectedEmpresaId == null || empresa.id !== selectedEmpresaId ? <button type="button" className='btn btn-sm btn-primary' onClick={() => { seleccionarEmpresa(empresa); }}>Seleccionar</button> : null}
                                    {selectedEmpresaId != null && empresa.id === selectedEmpresaId ? <button type="button" className='btn btn-sm btn-primary' onClick={() => { deseleccionarEmpresa(empresa); }}>Cerrar</button> : null}
                                </div>
                            </td>
                        </tr>
                    ))}
                </tbody>
            </table>
        </div>
    );
}

export default GrupoEmpresasTabla;
